import React, { useState, useEffect, useRef, useCallback, useReducer } from 'react';

import './HeaderSearch.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import config from '../../config';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EmailSubscription from '../../widgets/EmailSubscription/EmailSubscription';
import envelopeSvg from '../../assets/images/common/envelope.svg';
import { useHistory, NavLink } from 'react-router-dom';
import Script from 'react-load-script';
import { fireTealiumEvent } from '../../utils/Helper';

const HeaderSearch = (props) => {
  const { isMobileMenu, i18n } = props;

  const history = useHistory();

  const curLang = i18n.locale;
  const [modal, setModal] = useState(false);
  const [email, setEmail] = useState('');
  const [emailInvalid, setEmailInvalid] = useState(false);
  const emailFormRef = useRef(null);

  const toggle = () => setModal(!modal);

  const searchPlaceholder = {
    sc: '搜寻',
    en: 'SEARCH',
    tc: '搜尋',
  };

  const emailPlaceholder = {
    sc: '订阅',
    en: 'SUBSCRIBE',
    tc: '訂閲',
  };

  const emailRules = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  const [formVersion, setFormVersion] = useState(0);
  const [emailFormVersion, setEmailFormVersion] = useState(0);

  const handleSubmit = (e) => {
    e.preventDefault();

    const searchInput = e.target.querySelector('#search-input');
    if (searchInput) {
      const inputValue = searchInput.value;

      if (inputValue && inputValue.trim()) {
        fireTealiumEvent(
          JSON.stringify({
            event_action: 'search',
            event_name: 'search_click',
            event_title: `Fashionally : Search (${curLang?.toUpperCase()})`,
            event_category: 'Top Menu',
            event_click: '1',
            site_url: '/virtual/fashionally/search.htm',
            link_category: 'Search',
            link_name: 'Search - Top Menu',
            // event_step: 'Search',
            search_keyword: inputValue,
          }),
        );
        history.push(`${config.routePathTo}/${curLang}/search?q=${encodeURIComponent(inputValue)}`);
        setFormVersion((prev) => prev + 1);
      }
    }
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    setEmailFormVersion((prev) => prev + 1);
  };

  //Fn
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleOpenEmailModel = useCallback(() => {
    if (email && email.trim()) {
      if (emailRules.test(email)) {
        setEmailInvalid(false);

        // set input history by Browser
        if (emailFormRef.current) {
          const tempButton = document.createElement('button');
          tempButton.id = 'temp-submit-btn';
          tempButton.style.display = 'none';
          tempButton.type = 'submit';

          emailFormRef.current.appendChild(tempButton);
          tempButton.click();

          emailFormRef.current.removeChild(tempButton);
        }
      } else {
        setEmailInvalid(true);
      }
      setModal(true);
    }
  }, [email]);

  const errorEmail = {
    sc: '错误的电邮',
    en: 'Your email is invalid.',
    tc: '錯誤的電郵',
  };

  return (
    <>
      {!isMobileMenu && (
        <>
          <div style={{ textAlign: 'right', marginTop: '20px' }}>
            <span className="mr-4">
              <form key={formVersion} onSubmit={handleSubmit} className="search-form">
                <div className="search-input-container">
                  <input
                    id="search-input"
                    className="search-input"
                    placeholder={searchPlaceholder[curLang]}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                  />
                  <span className="search-input-span">
                    <button className="search-btn">
                      <FontAwesomeIcon icon={faSearch} className="search-input-icon" />
                    </button>
                  </span>
                </div>
              </form>
            </span>
            <span>
              <form
                key={emailFormVersion}
                className="email-form"
                onSubmit={handleEmailSubmit}
                ref={emailFormRef}
              >
                <input
                  className="email-input"
                  placeholder={emailPlaceholder[curLang]}
                  type="email"
                  value={email}
                  id="email-input"
                  onChange={handleEmailChange}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                    }
                  }}
                />
                {` `}
                <div className="email-icon" onClick={() => handleOpenEmailModel()}></div>
              </form>
            </span>
          </div>
        </>
      )}

      {isMobileMenu && (
        <>
          <div className="custom-rc-menu-item">
            <form key={formVersion} onSubmit={handleSubmit} className="search-form">
              <div className="search-input-container">
                <input
                  id="search-input"
                  className="search-input"
                  placeholder={searchPlaceholder[curLang]}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                    }
                  }}
                />
                <span className="search-input-span">
                  <button className="search-btn">
                    <FontAwesomeIcon icon={faSearch} className="search-input-icon" />
                  </button>
                </span>
              </div>
            </form>
          </div>
          <div className="custom-rc-menu-item">
            <form
              key={emailFormVersion}
              className="email-form"
              onSubmit={handleEmailSubmit}
              ref={emailFormRef}
            >
              <input
                className="email-input"
                placeholder={emailPlaceholder[curLang]}
                type="email"
                value={email}
                id="email-input"
                onChange={handleEmailChange}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}
              />
              {` `}
              <div className="email-icon" onClick={() => handleOpenEmailModel()}></div>
            </form>
          </div>
        </>
      )}

      <Modal isOpen={modal} toggle={toggle} size={'lg'} id="subscribeModal">
        <ModalBody>
          {emailInvalid && (
            <div id="invalid-msg-wrapper">
              <span>{errorEmail[curLang]}</span>
            </div>
          )}
          {!emailInvalid && (
            <EmailSubscription selectEmail={email} curLang={curLang} emailRules={emailRules} />
          )}
        </ModalBody>
        {/* { emailInvalid && (
            <ModalFooter>
              <div id="confirmBtn" >
                {okText[curLang]}
              </div>
            </ModalFooter>
          )} */}
      </Modal>
      <Script
        url="https://ssl.captcha.qq.com/TCaptcha.js"
        // onLoad={()=>{
        // }}
        // onError={handleScriptError}
      />
      <Script
        url={`https://www.google.com/recaptcha/api.js`}
        // url={`https://www.google.com/recaptcha/enterprise.js?render=explicit`}
        // onLoad={()=>{
        // }}
        // onError={handleScriptError}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(HeaderSearch);

export { HeaderSearch as HeaderSearchComponent }; // <- For component Unit Test
export default connectStore;
